import React, {Component} from 'react';
import logo from "../../public/assets/images/symphony_logo_new.jpg";
import default_image from "../../public/assets/images/users/1.png";
import {getUser, getCurrentLocation} from '../../utils/TokenManager';
import {isEmpty} from 'lodash';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import * as StaffDashboardAction from "../../actions/StaffDashboardAction";
import ProfileModal from '../staffDashboard/ProfileModal';
import * as AuthAction from "../../actions/AuthAction";
import ChangePasswordModal from "../staffDashboard/ChangePasswordModal";

class TopNav extends Component {
    state = {
        locations: [],
        isLoading: false,
        defaultLocation: '',
        isOwner: false,
        userName: "",
        agencyName: "",
        openProfileModal: false,
        openToogle : false,
        openSupportModal: false
    }

    componentDidUpdate(prevProps) {
        if (this.props.agencyLocationList.length !== prevProps.agencyLocationList.length) {
            this.getInitialData();
        }
    }

    getInitialData = () => {
        if (typeof getUser() && !isEmpty(getUser())) {
            const user = getUser();
            const userName = user.first_name;
            this.setState({userName});
            let currentLocation = getCurrentLocation();
            let locations = this.props.agencyLocationList;
            let isOwner = (user.role.access_level === 1);
            if (locations && locations.length >= 1) {
                this.setState({
                    isOwner: isOwner,
                    locations: locations,
                    defaultLocation: currentLocation,
                    agencyName: user.agency_name
                });
            }
        }
    };

    static getDerivedStateFromProps = (nextProps, prevState) => {
        return {
            locations: nextProps.agencyLocationList
        }
    };

    handleChange = (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({defaultLocation: value});
        this.props.actions.AgencyLocation.setChangedLocation(value);
    };

    logout = () => {
        this.props.actions.AgencyLocation.logOut();
    };

    openProfile = () => {
        this.setState({openProfileModal: true});
    };

    toggleProfileModal = () => {
        this.setState((prevState) => ({openProfileModal: !prevState.openProfileModal}));
    };

    openChangePassword = () => {
        this.setState({openPasswordModal: true});
    }

    togglePasswordModal = () => {
        this.setState((prevState) => ({openPasswordModal: !prevState.openPasswordModal}));
    };


    render = () => {
        let locationOptions = [];
        if (this.state.locations.length) {
            locationOptions = this.state.locations.map((location) =>
                <option key={location.id} value={location.id}>{location.name}</option>
            );
        }

        return (
            <header className="topbar topbar-border">
                <nav className="navbar top-navbar navbar-expand-md navbar-light">
                    <div className="navbar-collapse collapse">
                        <ul className="navbar-nav float-left mr-auto">
                            <li className="nav-item px-2">
                                <div className="navbar-header topbar-border">
                                    <a title="Symphony Home"> 
                                        <span className="logo-text">
                                            <img src={logo} alt="homepage" 
                                                style={{height: "52px", width: "auto"}}
                                            />
                                        </span>
                                    </a>
                                </div>
                            </li>
                            <li className="nav-item nav-location px-2">
                                {this.state.agencyName}
                            </li>
                            {locationOptions.length > 1 ? 
                                <li className="nav-item nav-location">
                                    <select name="location_name"
                                            className="form-control-sm"
                                            onChange={this.handleChange}
                                            value={this.state.defaultLocation}>
                                        {locationOptions}
                                    </select>
                                </li>
                                : ''
                            }
                        </ul>
                        <ul className="navbar-nav float-right">
                            <li className="pt-2 pr-3 nav-location">Welcome back {this.props.authData.profile.first_name}</li>
                            <UncontrolledDropdown color = '#555555'>
                                <DropdownToggle nav={true} className="text-center p-1">
                                    <img src={!this.props.authData.profile.image_path || this.props.authData.profile.image_path === '' ?  default_image : this.props.authData.profile.image_path}
                                    alt="user" className="rounded-circle" width="30" height="30" onError={(e) => e.target.src=default_image} />
                                    &nbsp;<i className="fa fa-caret-down image-caret-down"></i> 
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={this.openProfile} href="javascript:">
                                        <i className="fa fa-edit"></i> Edit Profile
                                    </DropdownItem>
                                    <DropdownItem onClick={this.openChangePassword} href="javascript:">
                                        <i className="fa fa-key"></i> Change Password
                                    </DropdownItem>
                                    <DropdownItem divider className="m-0" />
                                    <DropdownItem onClick={this.logout} href="javascript:">
                                        <i className="fa fa-power-off"></i> Logout
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </ul>
                    </div>
                </nav>
                {this.state.openProfileModal ?
                    <ProfileModal {...this.props} openProfileModal={this.state.openProfileModal} toggleProfileModal={this.toggleProfileModal} />
                        : null
                }
                {this.state.openPasswordModal ? 
                    <ChangePasswordModal {...this.props} modal={this.state.openPasswordModal} toggleModal={this.togglePasswordModal} {...this.props.actions.StaffDashboard} />
                : null
                }
            </header>
        );
    };
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        agencyLocationList: state.LocationListReducer,
        authData: state.AuthReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            AgencyLocation: bindActionCreators(AuthAction, dispatch),
            StaffDashboard: bindActionCreators(StaffDashboardAction, dispatch),
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);



// WEBPACK FOOTER //
// ./src/components/installationWizard/TopNav.js